import React, { useEffect, useState } from "react";
import Footer from "../components/footer";
import NavBar from "../components/navbar";
import PocketBase from "pocketbase";
import Parser from "html-react-parser";

export default function about() {
  const pb = new PocketBase("https://friendsofstandrewsstatepark.org");
  // eslint-disable-next-line react-hooks/rules-of-hooks
  let [boardMembers, setBoardMembers] = useState([]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  let [membersAtLarge, setMembersAtLarge] = useState([]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  let [codeOfEthics, setCodeOfEthics] = useState();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  let [prevPresidents, setPreviousPresidents] = useState([]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    (async () => {
      const boardMembers = await pb.collection("board_members").getFullList({
        sort: "order_of_appearance",
      });
      const membersAtLarge = await pb
        .collection("members_at_large")
        .getFullList({ sort: "-created" });
      const coe = await pb
        .collection("documents")
        .getFullList({ sort: "created" });
      const previousPresidents = await pb
        .collection("previous_presidents")
        .getFullList({ sort: "Start" });
      setBoardMembers(boardMembers);
      setCodeOfEthics(coe);
      setMembersAtLarge(membersAtLarge);
      setPreviousPresidents(previousPresidents);
    })();
  }, []);

  return (
    <div className="content d-flex flex-fill fsa-body-bg">
      <div className="d-flex flex-column flex-fill justify-content-between">
        <NavBar />
        <div className="d-flex flex-column align-items-center px-3 pt-4 pb-5">
          <h1 className="fsa-section-title">
            Friends of St. Andrews State Park
          </h1>

          <div
            className="d-flex flex-column flex-lg-row gap-3 w-100 justify-content-center mb-4"
            style={{ maxWidth: 900 }}
          >
            <div className="card flex-fill">
              <div className="card-header fsa-card-header">
                <h5
                  className="mb-0"
                  style={{ color: "white", fontFamily: "inherit" }}
                >
                  Board of Directors
                </h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled mb-0">
                  {boardMembers.length > 0 ? (
                    boardMembers.map((member, inx) => (
                      <li
                        key={inx}
                        className="py-1 border-bottom"
                        style={{ borderColor: "rgba(17,43,82,0.08)" }}
                      >
                        <span className="fw-semibold">{member.title}:</span>{" "}
                        {member.name}
                      </li>
                    ))
                  ) : (
                    <li className="text-muted fst-italic">None Found</li>
                  )}
                </ul>
              </div>
            </div>

            <div className="card flex-fill">
              <div className="card-header fsa-card-header">
                <h5
                  className="mb-0"
                  style={{ color: "white", fontFamily: "inherit" }}
                >
                  Members At Large
                </h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled mb-0">
                  {membersAtLarge.length > 0 ? (
                    membersAtLarge.map((member, inx) => (
                      <li
                        key={inx}
                        className="py-1 border-bottom"
                        style={{ borderColor: "rgba(17,43,82,0.08)" }}
                      >
                        {member.name}
                      </li>
                    ))
                  ) : (
                    <li className="text-muted fst-italic">None Found</li>
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className={"card w-75 mb-4"} style={{ maxWidth: 900 }}>
            <div className="card flex-fill">
              <div className="card-header fsa-card-header">
                <h5
                  className="mb-0"
                  style={{ color: "white", fontFamily: "inherit" }}
                >
                  Previous Presidents
                </h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled mb-0">
                  {prevPresidents.length > 0 ? (
                    prevPresidents.map((member, inx) => (
                      <li
                        key={inx}
                        className="py-1 d-flex align-items-center justify-content-between border-bottom"
                        style={{ borderColor: "rgba(17,43,82,0.08)" }}
                      >
                        {member.name}
                        {member.Start && member.End ? (
                          <span className="text-muted fst-italic">
                            {" "}
                            {new Date(member.Start).toLocaleDateString(
                              "en-US",
                              { month: "2-digit", year: "numeric" },
                            )}{" "}
                            -{" "}
                            {new Date(member.End).toLocaleDateString("en-US", {
                              month: "2-digit",
                              year: "numeric",
                            })}
                          </span>
                        ) : (
                          ""
                        )}
                      </li>
                    ))
                  ) : (
                    <li className="text-muted fst-italic">None Found</li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          <div
            className="d-flex flex-column gap-3 w-100"
            style={{ maxWidth: 900 }}
          >
            <div className="card">
              <div className="card-header fsa-card-header">
                <h5
                  className="mb-0"
                  style={{ color: "white", fontFamily: "inherit" }}
                >
                  Friends Code of Ethics
                </h5>
              </div>
              <div className="card-body">
                {codeOfEthics ? (
                  Parser(codeOfEthics[0].body)
                ) : (
                  <span className="text-muted fst-italic">Not Found</span>
                )}
              </div>
            </div>

            <div className="card">
              <div className="card-header fsa-card-header">
                <h5
                  className="mb-0"
                  style={{ color: "white", fontFamily: "inherit" }}
                >
                  Bylaws
                </h5>
              </div>
              <div className="card-body">
                {codeOfEthics ? (
                  Parser(codeOfEthics[1].body)
                ) : (
                  <span className="text-muted fst-italic">Not Found</span>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
